import React from 'react';
import LinkSessionStatus from '../_shared/LinkSessionStatus';
import { LINK_SESSION_STATUS } from '../../hooks/useAgendeaiLinkSession';

function LinkExpired() {
	return (
		<LinkSessionStatus
			status={LINK_SESSION_STATUS.LINK_EXPIRED}
			expiredDescription="Solicite um novo link para realizar o seu agendamento."
		/>
	);
}

export default LinkExpired;
